import { get, post } from "./axios";
import { SupportedLocales } from "../views/IntlContext";

const prefix = "/clevast/api";

export enum ThirdPartyService {
  alexa = "Alexa",
  googleAssistant = "Google Assistant",
  googleFit = "Google Fit",
  appleHealth = "Apple Health",
  huaweiHealth = "Huawei Health",
}

export interface IDeviceInfo {
  nickname: string;
  name: string;
  productModel: string;
  mcuVersion: string;
}

export type IAuth = {
  token?: string;
  lang?: SupportedLocales;
};

export type IDeviceBody = IAuth & {
  id: string;
};

export type ICommandBody = IAuth & {
  productId?: string | number;
};

export type IProductManualBody = IAuth & {
  productId?: string | number;
};

export type IResetPasswordBody = IAuth & {
  data: {
    newPassword: string;
    code: string;
  };
};

export type IAutLoginBody = {
  params: {
    email: string;
    password: string;
    client_id: string;
    redirect_uri: string;
    state: string;
  };
};

export type IService = {
  id: number;
  name: string;
  type: number;
  image: string;
  status: boolean;
  updateTime: number;
  createTime: number;
  delFlag: boolean;
};

export type IProduct = {
  id: string;
  name: string;
  picture: string;
  nickname: string;
  model: string;
  status: null;
  type: number;
  productId: string;
  productName: string;
  deviceId: string;
  temperatureType: number;
  productTypeId: string | null;
  productType: string | null;
  paring: number;
  reminderType: null;
};

export const deviceInfo = (data: IDeviceBody) => {
  return get({
    ...data,
    url: `${prefix}/device/info/${data.id}`,
  });
};

export const thirdPartyVoiceServices = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/common/thirdSound/listAll` });
};

export const supportGoogleProduct = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/product/google` });
};

export const supportAlexaProduct = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/product/alexa` });
};

// third health apple health and google fit  details
export const supportHealthProduct = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/product/health` });
};

export const userDeviceList = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/user/device` });
};

export const commandList = (data: ICommandBody) => {
  return get({
    ...data,
    url: `${prefix}/product/command/list?productId=${data.productId}`,
  });
};

export const productManual = (data: IProductManualBody) => {
  return get({
    ...data,
    url: `${prefix}/product/explain?productId=${data.productId}`,
  });
};

export const resetPassword = (data: IResetPasswordBody) => {
  return post({
    ...data,
    url: `${prefix}/user/forget`,
  });
};

export const alexaAuth = (data: IAutLoginBody) => {
  return get({
    ...data,
    baseURL: process.env.REACT_APP_ALEXA_API_URL,
    url: `/user/login`,
  });
};

export const googleAuth = (data: IAutLoginBody) => {
  return get({
    ...data,
    baseURL: process.env.REACT_APP_GOOGLE_API_URL,
    url: `/user/login`,
  });
};

export const alexaUnlink = (data: IAuth) => {
  return post({
    ...data,
    url: `${prefix}/alexa/disable`,
  });
};

export const productList = (data: IAuth) => {
  return get({ ...data, url: `${prefix}/product/info` });
};
